import React from "react";
import marked from "marked";
import dompurify from "dompurify";
import ProductEnergyRating from "./ProductEnergyRating";

interface ProductIntroProps {
    heroTitle: string;
    description: string;
    largeThumbFilename:string;
    terms?: string;
}

const ProductIntro = (props:ProductIntroProps) => {
    return (
        <>
            <div className="product-intro">
                <div className="onepcssgrid-1300">
                    <div className="onerow">
                        <nav className="col12 last container">
                            
                            <div className="description">
                                <h3>{props.heroTitle}</h3>
                                <div dangerouslySetInnerHTML={{__html: dompurify.sanitize(marked.parse(props.description))}}></div>
                            </div>
                            
                            <div className="product-image">
                                <img src={props.largeThumbFilename} />
                            </div>
                        </nav>
                    </div>
                </div>
            </div>

            {props.terms && <div className="product-terms onepcssgrid-1300">
                <div className="onerow">
                    <div className="col12 last">
                        {props.terms}
                    </div>
                </div>
            </div>}
        </>
    )
}

export default ProductIntro;